'use client'

import { FC, useEffect, useMemo, useState } from 'react'
import { Tariff } from '@/root/shared-types'
import { Tabs } from '@/root/modules/tuuleliinid/AppLayout/components/Tabs/Tabs'
import { TariffsTable } from '@/root/modules/tuuleliinid/TariffsPage/components/TariffsTable/TariffsTable'
import { useGetTranslations } from '@/root/shared-hooks'
import { ContentContainer } from '@/root/ui/tuuleliinid'
import { PageTitle } from '@/root/modules/tuuleliinid'

interface TariffsPageProps {
  tariffs?: Tariff[]
}

export const TariffsPage: FC<TariffsPageProps> = ({ tariffs = [] }) => {
  const { getTranslation } = useGetTranslations()

  const tabs = tariffs.map((t) => t.title)

  const [currentTab, setCurrentTab] = useState('')

  const tabsKey = useMemo(() => tabs.join('|'), [tabs])

  useEffect(() => {
    if (!tariffs.length) {
      setCurrentTab('')
      return
    }

    setCurrentTab((prev) => {
      if (!prev) return tariffs[0].title
      const exists = tariffs.some((t) => t.title === prev)
      return exists ? prev : tariffs[0].title
    })
  }, [tabsKey, tariffs])

  const currentTariff = tariffs.find((t) => t.title === currentTab)

  return (
    <ContentContainer>
      <PageTitle>{getTranslation('tariffsPageTitle')}</PageTitle>

      {!!tabs.length && !!currentTab && (
        <Tabs tabs={tabs} currentTab={currentTab} setTab={setCurrentTab} />
      )}

      {currentTariff && (
        <TariffsTable cols={currentTariff.data.cols} rows={currentTariff.data.rows} />
      )}
    </ContentContainer>
  )
}
